import { ORIENTATION } from '../constants';
import { createSelector } from 'reselect';
export const getOrientationItems = createSelector([(state) => state.page.size, (state) => state.page.template, (state, locale) => locale], (size, template, locale) => {
    if (!template || !template.pageSize)
        return [];
    return Object.keys(ORIENTATION).reduce((orientations, o) => {
        const orientation = o.toLowerCase();
        template.pageSize[size][orientation] &&
            orientations.push({
                value: orientation,
                label: locale[orientation] || orientation,
            });
        return orientations;
    }, []);
});
//# sourceMappingURL=selectors.js.map